import React from 'react';
import { testimonials } from '../data/content';
import './Testimonials.css';

export default function Testimonials() {
  return (
    <section className="testi-section" id="testimonials">
      <span className="section-eyebrow">Real Stories</span>
      <h2 className="section-title">Families Transforming<br />Their Wellness</h2>

      <div className="testi-grid">
        {testimonials.map((t) => (
          <div className="testi-card" key={t.name}>
            <div className="stars">{'★'.repeat(t.stars)}</div>
            <p className="testi-text">{t.text}</p>
            <div className="testi-author">
              <div className="testi-avatar">{t.avatar}</div>
              <div>
                <div className="testi-name">{t.name}</div>
                <div className="testi-loc">{t.location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
